import { httpClient } from '@/services/http/httpClient'
import { getTenantByCookies } from '@/utils/getTenantByCookies'

type ActiveUsersRate = {
  activeUsers: number
  totalUsers: number
  percentage: string
}

type Params = {
  startDate?: Date
  endDate?: Date
}

async function getDashboardActiveUsersRate({
  startDate,
  endDate,
}: Params): Promise<ActiveUsersRate> {
  const tenant = await getTenantByCookies()

  if (tenant?.slug === 'trial') {
    return {
      activeUsers: 1000,
      totalUsers: 10000,
      percentage: '10%',
    }
  }

  const queryParams = new URLSearchParams({
    ...(startDate && { startDate: startDate.toISOString() }),
    ...(endDate && { endDate: endDate.toISOString() }),
  })
  const query = queryParams.toString() ? `?${queryParams.toString()}` : ''
  const { data } = await httpClient.get<ActiveUsersRate>(
    `/users/dashboard/active-users-rate${query}`,
  )
  return {
    activeUsers: data.activeUsers ?? 0,
    totalUsers: data.totalUsers ?? 0,
    percentage: data.percentage ?? '0%',
  }
}

export { getDashboardActiveUsersRate, type ActiveUsersRate }
